import CheckoutCheckin from '../components/Indicators/CheckoutCheckin.vue'
import Reserved_Retreat from '../components/Indicators/reserved_retreat.vue'
import Ranking_Users from '../components/Indicators/ranking_users.vue'
import Ranking_Departments from '../components/Indicators/ranking_departments.vue'
import Main_Problems from '../components/Indicators/main_problems.vue'
import Main_Reasons from '../components/Indicators/main_reasons.vue'
import Main_Items from '../components/Indicators/main_items.vue'
import RideIndicators from '../components/Indicators/RideIndicators.vue'

let routes = {
    path: '/indicators',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/indicators/checkout_checkin',
            name: 'Indicadores - Check-out X Check-in',
            component: CheckoutCheckin
        },
        {
            path: '/indicators/reserved_retreat',
            name: 'Indicadores - Reservados X Retirados',
            component: Reserved_Retreat
        },
        {
            path: '/indicators/ranking_users',
            name: 'Indicadores - Ranking de Usuários',
            component: Ranking_Users
        },
        {
            path: '/indicators/ranking_departments',
            name: 'Indicadores - Ranking de Centro de Custos',
            component: Ranking_Departments
        },
        {
            path: '/indicators/main_problems',
            name: 'Indicadores - Principais Problemas Detectados',
            component: Main_Problems
        },
        {
            path: '/indicators/main_items',
            name: 'Indicadores - Principais Itens Faltantes Detectados',
            component: Main_Items
        },
        {
            path: '/indicators/main_reasons',
            name: 'Indicadores - Principais Motivos de Reserva',
            component: Main_Reasons
        },
        {
            path: '/indicators/ride_indicators',
            name: 'Indicadores - Caronas',
            component: RideIndicators
        },
    ]
}


export default routes



// WEBPACK FOOTER //
// ./src/router/indicators.js